/* @flow */
import React, { useMemo } from 'react';
import { Animated } from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';

import l from '../utils/localization';
import { useTheme } from './theme';


export type ActionConfig = {
  icon: { name: string },
  status: string,
  color: string
}

const deleteAction = {
        status: 'deleted', title: l.status_deleted.toUpperCase(), IconSet: Animated.createAnimatedComponent(MaterialCommunityIcons), icon: { name: 'delete' }, color: 'white', iconName: 'trash-can',
      },
      todoAction = {
        status: 'todo', title: l.status_todo.toUpperCase(), IconSet: Animated.createAnimatedComponent(MaterialIcons), icon: { name: 'list' }, color: 'white', iconName: 'list',
      },
      postponeAction = {
        status: 'postponed', title: l.status_postponed.toUpperCase(), IconSet: Animated.createAnimatedComponent(MaterialCommunityIcons), icon: { name: 'access-time' }, color: 'white', iconName: 'clock',
      },
      doneAction = {
        status: 'done', title: l.status_done.toUpperCase(), IconSet: Animated.createAnimatedComponent(MaterialIcons), icon: { name: 'check' }, color: 'white', iconName: 'check',
      };

export type ActionContext = {
  delete: ActionConfig,
  todo: ActionConfig,
  postpone: ActionConfig,
  done: ActionConfig
}

const ActionsContext = React.createContext<ActionContext>({
  delete: deleteAction,
  todo: todoAction,
  postpone: postponeAction,
  done: doneAction,
});

type Props = {
  children: Array<any>,
}

export const Provider = ({ children }: Props) => {
  const { colors, icons } = useTheme(),
        actions = useMemo(() => ({
          delete: { ...deleteAction, color: colors.delete, icon: icons.delete },
          todo: { ...todoAction, color: colors.list, icon: icons.list },
          postpone: { ...postponeAction, color: colors.postpone, icon: icons.postpone },
          done: { ...doneAction, color: colors.done, icon: icons.done },
        }), [colors, icons]);

  return (
    <ActionsContext.Provider value={actions}>
      { children }
    </ActionsContext.Provider>
  );
};

export const withActions = (WrappedComponent: any, propName = 'actions') => function withActionsHOC(props: any) {
  return (
    <ActionsContext.Consumer>
      {(actions) => {
        const actionsProps = { [propName]: actions };
        return (
          <WrappedComponent
            {...props}
            {...actionsProps}
          />
        );
      }}
    </ActionsContext.Consumer>
  );
};

export default ActionsContext;
